export default __webpack_public_path__ + "a3c96e1c06391ef9085b9111550c4313.gif";